import { Button, Group, Modal, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const getTabId = () => {
  return (
    sessionStorage.getItem('tabId') ??
    (() => {
      const id = crypto.randomUUID();
      sessionStorage.setItem('tabId', id);
      return id;
    })()
  );
};

export const RoleChangedReloadModal = () => {
  const [opened, { open }] = useDisclosure();
  const { t } = useTranslation();

  useEffect(() => {
    const tabId = getTabId();

    const channel = new BroadcastChannel('role-change-events');

    channel.onmessage = event => {
      const { from } = event.data;

      if (from === tabId) return;

      open();
    };

    return () => {
      channel.close();
    };
  }, []);

  return (
    <Modal
      opened={opened}
      onClose={() => {
        /* no-op */
      }}
      withCloseButton={false}
      centered
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      title={t('roleChangedReloadModal.title')}
    >
      <Group>
        <Text>{t('roleChangedReloadModal.content')}</Text>
        <Button
          onClick={() => {
            location.reload();
          }}
        >
          {t('roleChangedReloadModal.action')}
        </Button>
      </Group>
    </Modal>
  );
};
